<template>

<div id="app" class="white pt-1">



<!-- <v-snackbar
  v-model="snackbar2"
  :timeout="3000"
  :centered="true"
  :bottom="false"
  :right="true"
  rounded="pill"
  :color="snack_color2" 
  class="mb-0"
  attrs
  >
  <center>
    {{ snack_text2 }}
  </center>
    <template v-slot:action="{ attrs }">
      <v-icon
        color="white"
        v-bind="attrs"
        >mdi-chat-processing
      </v-icon>
    </template>
</v-snackbar> -->



  
  <v-fab-transition>
              <template>


                
                <v-btn
                  style="margin-bottom: 72px; position: fixed;"
                  :class="(count_pendente>0) ? 'blue' : 'blue'"
                  color=""
                  absolute
                  bottom
                  right
                  fab
                  @click="abrir()"
                  :x-large="count_pendente>0"
                >
                


                  <v-snackbar
                    v-model="snackbar2"
                    :timeout="3000"
                    :centered="false"
                    :bottom="true"
                    :right="true"
                    rounded="pill"
                    :color="snack_color2" 
                    class="mb-10 mr-2"
                    attrs
                    >
                    <center>
                      {{ snack_text2 }}
                    </center>
                      <template v-slot:action="{ attrs }">
                        <v-icon
                          class="pr-4"
                          size="34"
                          color="white"
                          v-bind="attrs"
                          >mdi-chat-processing
                        </v-icon>
                      </template>
                  </v-snackbar>

                  <v-icon
                   :size="(isMobile) ? 32 : 34"
                   :color="(count_pendente > 0) ? 'white' : 'white'"
                  >mdi-chat-processing </v-icon>

                  <span
                  :class="[isMobile ? 'ml-1' : 'ml-1', 'mb-4', 'white--text']"
                  v-if="count_pendente>0"  
                  >
                    <strong> {{ count_pendente }} </strong>
                  </span>

                </v-btn>

              </template>
    </v-fab-transition>

   <div class="primary pa-2 mt-2" v-if="aberto"
    style="border-radius: 8px;"
   >

<v-dialog
 v-model="aberto"
 :width="(isMobile) ? '350' : '550'"
 :persistent="false"
 @click:outside="abrir()"
>

  <v-container
  :class="[cor_fundo, 'pa-4']"
  >


  <!-- DSI -->
  <!-- {{ items_mensagens }} -->
  <!-- {{ chat_agora }} -->


  <!-- {{ user_selecionado }} -->
  <!-- {{ scrollPosition }} -->

          <!-- chip novas mensagens -->
          <v-row>
            
              <v-col
              :cols="colunas-1"
              class="pa-0 pt-2"
              >

              <v-card
              height="47"
              :class="[cor_fundo]"
              elevation="0"
              >
              
              <!-- <span
               class="white--text"
               v-if="items_count_new<1"
              >
                versão beta
              </span> -->

              <!-- items_count_new -->
                  <h4 class="white--text ml-2 mb-1"> <v-icon color="white">mdi-chat-processing</v-icon> Chat</h4>
                  
                  <v-chip
                      v-for="(item, index) in items_count_new"
                      :key="index"
                      color="grey lighten-2"
                      class="ml-1 mb-1 pa-2 black--text"
                      
                      small
                      @click="ver_msg(item.DE)"
                    >
                          {{ item.DE }} 
                          <span
                            class="mb-1 ml-1 red--text"
                          >
                            <strong> {{ item.NEW }} </strong>
                          </span>
                  </v-chip>
                </v-card>
              </v-col>

              <v-col
              cols="1"
              class="pa-0 mt-2"
              >
              <v-icon
                color="white"
                @click="abrir()"
              >
                mdi-close
              </v-icon>
              </v-col>
          </v-row>

          <!-- lista de usuarios -->
          <v-row>
            <v-col
              :cols="colunas"
              :class="[cor_fundo,'mt-2 pa-1 pt-0 pb-0']"
            >
            <!-- {{ items_usuarios }} -->

            <!-- <v-btn
            @click="play()"
            >
              REFRESH
            </v-btn> -->

           

            <v-select
              class="white lighten-4 pt-4 px-3"
              dense
              v-model="user_selecionado"
              label="Conversar com .."
              :items="items_usuarios"
              item-text='USUARIO'
              return-object
              color=""
              @change="open_mensagem(user_selecionado.USUARIO)"
              v-if="simples"
            >

            <template slot='item' slot-scope='{ item }'>
                  <v-icon
                  :color="item.ONLINE == 'S' ? 'green' : 'grey'"
                  x-small
                  >
                    mdi-circle 
                  </v-icon>
                  &nbsp

                {{ item.USUARIO }}

                <span
                  class="mb-1 ml-1 red--text"
                  v-if="item.NEW > 0"
                >
                  <strong> {{ item.NEW }} </strong>
                </span>

              </template>

          </v-select>

          <v-combobox
              v-else
              class="white lighten-4 pt-4 px-3"
              dense
              v-model="user_selecionado"
              label="Conversar com .."
              :items="items_usuarios"
              item-value='CODIGO'
              item-text='USUARIO'
              return-object
              color=""
              clearable
              @change="open_mensagem(user_selecionado.USUARIO)"
            >
            <template slot='item' slot-scope='{ item }'>
                  <v-icon
                  :color="item.ONLINE == 'S' ? 'green' : 'grey'"
                  x-small
                  >
                    mdi-circle 
                  </v-icon>
                  &nbsp

                {{ item.USUARIO }}

                <span
                  class="mb-1 ml-1 red--text"
                  v-if="item.NEW > 0"
                >
                  <strong> {{ item.NEW }} </strong>
                </span>

              </template>
            </v-combobox>






            <div class="text-center">
              <v-progress-linear
                value="0"
                indeterminate
                color="blue"
                v-if="carregando_msg"
              />
            </div>

            </v-col>
          </v-row>

          <!-- mensagens -->
          <v-row>
            <v-col
            :cols="colunas"
            :class="[cor_fundo, 'py-0 px-1']"
            >
            <v-card
                flat
                max-height="70vh"
                  >

                    <v-card-text :class="[cor_fundo, 'px-0 py-1 flex-grow-1 overflow-y-auto']">

                      <!-- {{items_mensagens}} -->
    
                      <v-container fluid style="padding: 0;">
                        <v-row no-gutters>
                          <v-col sm="12" style="position: relative;">
                            <div 
                               class="chat-container"  ref="chatContainer" id="id_sala" 
                               @scroll="usou_scroll($event)"
                            >

                              <div>
                                <div class=" message pt-2" v-for="(message,index) in items_mensagens" v-bind:key="index" :class="{own: message.DE == eu_sou}">
                                  <div class="username" v-if="index>0 && items_mensagens[index-1].DATA != message.DATA">{{getFormatDate(message.DATA)}}</div>
                                  <div class="username" v-if="index == 0">{{getFormatDate(message.DATA)}}</div>

                                  <div :class="[((message.JALEU == 'N')&&(message.DE != eu_sou) ? 'grey lighten-2' : 'white'), 'content']">
                                    <div>
                                      <!-- {{ message.JALEU }} -->
                                      {{message.MENSAGEM}}
                                      <span class="hora">{{ getFormatTime(message.HORA) }}</span>
                                        </div>
                                    <!-- <chat-image v-if="message.image" :imgsrc="message.image" @imageLoad="imageLoad"></chat-image> -->
                                  </div>
                                </div>

                                <v-fab-transition>
                                  <v-btn
                                    style="margin-bottom: 70px; margin-right: -15px;"
                                    v-show="scrollPosition == 'meio'"
                                    color="primary"
                                    dark
                                    absolute
                                    bottom
                                    right
                                    fab
                                    x-small
                                    @click="scroll_to('id_sala', 1)"
                                  >
                                    <v-icon>mdi-chevron-up </v-icon>
                                  </v-btn>
                                </v-fab-transition>

                                <v-fab-transition>
                                  <v-btn
                                    style="margin-bottom: 35px; margin-right: -15px;"
                                    v-show="scrollPosition == 'meio'"
                                    color="primary"
                                    dark
                                    absolute
                                    bottom
                                    right
                                    fab
                                    x-small
                                    @click="scroll_to('id_sala', 999999)"
                                  >
                                    <v-icon>mdi-chevron-down </v-icon>
                                  </v-btn>
                                </v-fab-transition>

                              </div>
                            </div>
                          </v-col>
                        </v-row>



                      </v-container>



                    </v-card-text>
                    <v-card-text 
                      class="white lighten-4 flex-shrink-1 mb-1"
                    >
                        <v-text-field
                        class="white mt-1"
                        dense
                        v-model="messageForm.content"
                        :label="(pesquisar)? 'Pesquisar mensagem' : 'Mensagem'"
                        type="text"
                        no-details
                        outlined
                        append-outer-icon="mdi-send"
                        @keyup.enter="envia_mensagem()"
                        @click:append-outer="envia_mensagem()"
                        @click="replace_objeto(items_mensagens)"
                        hide-details
                      >
                      </v-text-field>
<!-- {{pesquisar}} -->
                      <v-fab-transition v-if="0>1">
                        <v-btn
                          style="margin-bottom: 72px; margin-left: -20px;"
                          color="primary"
                          dark
                          absolute
                          bottom
                          left
                          fab
                          x-small
                          @click="pesquisar=!pesquisar"
                        >
                          <v-icon v-if="pesquisar">mdi-chat-processing</v-icon>
                          <v-icon v-else>mdi-magnify</v-icon>
                        </v-btn>
                      </v-fab-transition>

                    </v-card-text>
                  </v-card>
            </v-col>
          </v-row>


  </v-container>
</v-dialog>
    <!-- </v-dialog> -->
  </div> 
</div>
</template>

<script>


import DSirotinas from '../assets/js/DSi_rotinas'//chamo funcao do arquivo
import DSibasico from '../assets/js/DSi_basico'//chamo funcao do arquivo
import DSisql from '../assets/js/DSi_sql'//chamo funcao do arquivo


export default {

  components:{
     
  },

  props:{
    aberto: Boolean,
  },

  data: () => ({    


    RASTREAR: true, //ativo pra ver as etapas da criação do app

    ESTA_LOGADO : false,

    // aberto: false,
    cor_fundo: 'primary lighten-0',

    isMobile: false,
    colunas: 12,

    snackbar2: false,
    snack_text2: 'Nova Mensagem',
    snack_color2: "success",

    simples: false,
    scrollPosition:'',

    pesquisar: false,

    campos_mensagem:{},

    chat_agora:'',
    user_selecionado:  '',
    recentes: [], 
    items_usuarios: [
      // {
      //   TITLE:'',
      //   ACTIVE:'',
      //   IDE:0,
      //   SEQ:0
      //   NEW
      // }
    ],

    meuTimer: null,
    meuTimer2: null,

    carregando_msg: false,

    items_mensagens: [],
    items_mensagens_atual: null,
    items_count_new: [],
    items_user_online: [],
    count_pendente: 0,

    eu_sou : '',
    lendo_de:'',

    hoje :'',
    hoje_week:'',
    hora :'',
    data_hora :'',
    today :'',
    quem_alterou:'',

    messageForm: {
      content: "",
      me: true,
      created_at: "11:11am"
    }
  }),


  created(){
    this.onCreated()
  },

  watch:{
    aberto(a){
      if (a){

       
        setTimeout(function(){
        
        // if (this.scrollPosition == ''){
          this.scroll_to('id_sala', 999999)
        // }
        
        }.bind(this), 500);//2 x por minuto
      

        // esta conversando com alguem
        if (this.chat_agora){
           this.open_mensagem_atual( this.chat_agora)//abre mensagem de quem esta falando no momento
           this.refreshStatus()//atualiza o count 
        }

      }
    },

    count_pendente(a){
      // console.log('watch count_pendente:'+ a);
      this.$emit('muda_count', a)
    }
  },

  methods:{


    async replace_objeto(ArrayObj){

      // recebo um array de objeto.. transformo em string..faço o replace dos dados que eu quero..depois volto para array
      // console.log(ArrayObj);
      let string =  JSON.stringify(ArrayObj)
      // console.log(string);
      
      string = string.replaceAll(`"JALEU":"N"`,`"JALEU":"S"`)
      let array = JSON.parse(string);

      // console.log(array);
      this.items_mensagens = array
    },

    async onCreated(){

       this.isMobile = window.innerWidth < 600
       await this.logado()//chamo funcoes basicas mas somente se logado
    },


    rastreia(tag){
      if (this.RASTREAR){
          console.log(tag);
      }
    },

    async logado(){

      let r = await DSirotinas.logado(this)
      this.ESTA_LOGADO = r

      if (r=='S'){
         await this.carregar_usuarios()
         await this.count_novas()
         await this.TimerAtivar()
      }

    },

    abrir(){
      // this.aberto=!this.aberto
      this.$emit('muda_aberto', !this.aberto)
    },

    pesquisar_mensagem(){

    },

    usou_scroll(e){

      // console.log(e.target.scrollTop);
      if ((e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 5))){
        //  console.log('no final');
         this.scrollPosition = 'bottom'
      }
      else if (e.target.scrollTop == 0){
        //  console.log('no começo');
         this.scrollPosition = 'top'
      }
      else{
        this.scrollPosition = 'meio'
      }
    },

    manda_emit(acao,a,b,c){
      this.$emit('emit_executa',acao,a,b,c)
    }, 

    ver_msg(de){
      // console.log(this.user_selecionado.USUARIO);
      // console.log('------');
      // console.log(this.user_selecionado);


      this.user_selecionado = de
      this.chat_agora       = de

      this.open_mensagem(de)

    },

    async refreshStatus(){

      await this.status_users()  
      await this.count_novas()

      await this.set_new()//define a qt de novas msg e se esta online ou nao

    },

    async envia_mensagem(para,msg){


      if (this.pesquisar){
         para = ''
         this.pesquisar_mensagem()
      }

      this.define_data_hora()//atualiza data hora

      if (para == undefined){
        para = this.chat_agora
      }

      if (msg == undefined){
        msg = this.messageForm.content
      }

      if ( (para.length >0) && (msg.length >0)){

        // console.log(para, msg)

        //limpa objs
        this.campos_mensagem = {}

        let de = this.eu_sou.toUpperCase()
        let grupo = '|'+de+'|'+para+'|'.toUpperCase()
        //valores default
        this.$set(this.campos_mensagem, 'DATA'  , this.today )
        this.$set(this.campos_mensagem, 'HORA'  , this.hora )
        this.$set(this.campos_mensagem, 'TIPO'  , 'M' )
        this.$set(this.campos_mensagem, 'JALEU'  , 'N' )
        this.$set(this.campos_mensagem, 'GRUPO'  , grupo )
        this.$set(this.campos_mensagem, 'DE'  ,  de )
        this.$set(this.campos_mensagem, 'PARA'  , para )
        this.$set(this.campos_mensagem, 'MENSAGEM'  , msg )

        // console.log(this.campos_mensagem);


        //limpa campos
        this.messageForm.content = ''


        this.items_mensagens.push(this.campos_mensagem)

        await this.tabela_create('MENSAGEM', this.campos_mensagem)

        this.scroll_to('id_sala', 999999)
        
      }


    },

    async atu_chat_agora(){
      // console.log(this.chat_agora);

      await this.open_mensagem_atual( this.chat_agora)
      
      if (this.scrollPosition !== 'meio'){
         this.scroll_to('id_sala', 999999)
      }
    },

    async ja_leu_codigo(codigo){

      this.define_data_hora()//atualiza data hora

      let sql = 
      `
       UPDATE MENSAGEM SET MENSAGEM.JALEU = 'S', LEU_EM = '${this.data_hora}' WHERE CODIGO = ${codigo}
      `
      // console.log(sql);

      await this.crud_sql(sql)
    },
    
    async ja_leu(de){

      this.define_data_hora()//atualiza data hora
      let sql = 
      `
       UPDATE MENSAGEM SET MENSAGEM.JALEU = 'S', LEU_EM  = '${this.data_hora}' WHERE JALEU = 'N' AND (upper(MENSAGEM.PARA) =upper('${this.eu_sou}')) AND (upper(MENSAGEM.DE) =upper('${de}'))
      `
      // console.log(sql);

      await this.crud_sql(sql)
    },

    async count_novas(de){

       de = this.eu_sou


       let sql = 
       `
       SELECT
        DISTINCT
        MENSAGEM.DE,
        COUNT(MENSAGEM.CODIGO) AS NEW
        FROM
        MENSAGEM
        WHERE
          (MENSAGEM.JALEU = 'N')AND
        (upper(MENSAGEM.PARA) =upper('${de}'))
        GROUP BY

        MENSAGEM.DE
       `

      //  console.log(sql);
       await this.crud_abrir_tabela(sql, 'items_count_new' )

    }, 

    async status_users(){

      if (this.aberto){

      
        let sql = 
        `
        SELECT 
          USUARIOS.USUARIO AS USUARIO,
          USUARIOS.ONLINE
          FROM
          USUARIOS
          WHERE
          (USUARIOS.DATA_ONLINE >= ADDMONTH('TODAY', -6)) AND
          (USUARIOS.USUARIO <> '${this.eu_sou}')
          ORDER BY USUARIO 
        `

        //  console.log(sql);
        await this.crud_abrir_tabela(sql, 'items_user_online' )
        
      }

      
    },

    async open_mensagem(de){


      //  console.log('open_mensagem');

       await this.ja_leu(de)//defino aqui JALEU = S para todas as mensagens

      // console.log(de);
      this.chat_agora = de

        if (de !== null){

           this.carregando_msg =  true 

            this.lendo_de = de
            // eu = this.eu_sou

            let sql = `
            SELECT
              MENSAGEM.CODIGO,
              MENSAGEM.DE,
              MENSAGEM.PARA,
              MENSAGEM.JALEU,
              MENSAGEM.DATAHORA,
              MENSAGEM.DATA,
              MENSAGEM.HORA,
              MENSAGEM.MENSAGEM,
              MENSAGEM.IP,
              MENSAGEM.ARQUIVAR,
              MENSAGEM.VALIDADE,
              MENSAGEM.LEU_EM
            FROM
            MENSAGEM
            WHERE
            ((DE = '${de}') OR
            (PARA = '${de}')) 
            AND
            ((DE = '${this.eu_sou}') OR
            (PARA = '${this.eu_sou}')) 
            ORDER BY
            DATA,HORA ASC
            `

            // console.log(sql);

          await this.crud_abrir_tabela(sql, 'items_mensagens' )

          if (this.scrollPosition !== 'meio'){
             this.scroll_to('id_sala', 999999)
          }

          this.carregando_msg =  false

          this.TimerChatAgora()

        }
    },
    
    async open_mensagem_atual(de){


      
      // alert(de)

      // console.log(de);
        if ((de !== null) && (this.aberto)){


            //  console.log('open_mensagem_atual:', de);

            let sql = `
            SELECT
              MENSAGEM.CODIGO,
              MENSAGEM.DE,
              MENSAGEM.PARA,
              MENSAGEM.JALEU,
              MENSAGEM.DATAHORA,
              MENSAGEM.DATA,
              MENSAGEM.HORA,
              MENSAGEM.MENSAGEM,
              MENSAGEM.IP,
              MENSAGEM.ARQUIVAR,
              MENSAGEM.VALIDADE,
              MENSAGEM.LEU_EM
            FROM
            MENSAGEM
            WHERE
            ((DE = '${de}') OR
            (PARA = '${de}')) 
            AND
            ((DE = '${this.eu_sou}') OR
            (PARA = '${this.eu_sou}')) 
            AND
            (JALEU = 'N')
            ORDER BY
            CODIGO ASC
            `

            // console.log(sql);
 
          await this.crud_abrir_tabela(sql, 'items_mensagens_atual' )


          // console.log('items_mensagens_atual:');
          // console.log(this.items_mensagens_atual)

            let apita = false
            //percorre mensagens recentes para descobrir ordem
            let h = this.items_mensagens_atual

            for (let i = 0; i < h.length; i++) {
              

                if (h[i].PARA == this.eu_sou){
              
                  apita = true

                  //adiciona valor ao seq para atualizar
                  this.items_mensagens.push(h[i]) 

                  this.ja_leu_codigo(h[i].CODIGO)
                }
            }

            if (apita){
              this.play()
              // nao esta pegando a sequencia certa.. quando manda e o desktop nao leu ainda
            }

        }
    },
    
  
    async open_usuarios(eu){

        let sql = `
        SELECT 
         USUARIOS.USUARIO AS USUARIO,
         USUARIOS.ONLINE,
         USUARIOS.CODIGO,
         0 AS SEQ,
         0 AS NEW
        FROM
         USUARIOS
        WHERE
         (USUARIOS.USUARIO <> '${eu}')
        ORDER BY ONLINE DESC
        `
        // console.log(sql);

       await this.crud_abrir_tabela(sql, 'items_usuarios' )

      //  console.log(this.items_usuarios);

    },
    
    async open_usu_recentes(eu){

        let sql = `
        SELECT * FROM (

        SELECT DISTINCT
          MENSAGEM.PARA,
          MAX(MENSAGEM.CODIGO) AS ULTIMO
        FROM
        MENSAGEM
        INNER JOIN USUARIOS ON (MENSAGEM.PARA=USUARIOS.USUARIO)
        WHERE
          (MENSAGEM.GRUPO CONTAINING '|${eu}|')
        GROUP BY
          MENSAGEM.PARA

          
          
        UNION


        SELECT DISTINCT
          MENSAGEM.DE,
          MAX(MENSAGEM.CODIGO) AS ULTIMO
        FROM
        MENSAGEM
        INNER JOIN USUARIOS ON (MENSAGEM.PARA=USUARIOS.USUARIO)
        WHERE
          (MENSAGEM.GRUPO CONTAINING '|${eu}|')
        GROUP BY
          MENSAGEM.DE

          )
          
          ORDER BY
          ULTIMO DESC
        `
        // console.log(sql);

      
        await  this.crud_abrir_tabela(sql, 'recentes' )
    
        await this.ordena_usuarios(eu)

    },

    async ordena_usuarios(eu){

        //percorre lista de operadores
        let meu_index = -1
        let r = this.items_usuarios
        for (let j = 0; j < r.length; j++) {
            //  console.log(r[j].USUARIO);

              //percorre mensagens recentes para descobrir ordem
            let h = this.recentes
            for (let i = 0; i < h.length; i++) {

              if (h[i].PARA == r[j].USUARIO){
                
                if (h[i].ULTIMO > this.items_usuarios[j].SEQ){ 
                   this.items_usuarios[j].SEQ = h[i].ULTIMO //acho o ultimo codigo de msg e seto no objeto e seto o valor
                }
              }              
            }

            if ( r[j].USUARIO == eu){
              meu_index = j
            }
        }

        //deleto meu nome
        // alert('estou no indece :'+meu_index)
        // this.items_usuarios.splice(meu_index, 1);


        // defino a ordem do array
        this.items_usuarios = await this.items_usuarios.sort(this.arrayOrderBy)
    },

    async set_new(eu){


      let agora = 0 //quantidade de novas msgs

      //percorre lista de operadores
      let r = this.items_usuarios
      for (let j = 0; j < r.length; j++) {
          //  console.log(r[j].USUARIO);

          this.items_usuarios[j].NEW = 0 //default 0

            //percorre mensagens recentes para descobrir ordem
          let h = this.items_count_new
          for (let i = 0; i < h.length; i++) {

            if (h[i].DE == r[j].USUARIO){
              
              //adiciona valor ao seq para atualizar
              // this.items_usuarios[j].SEQ = parseInt(this.items_usuarios[j].SEQ) + parseInt(h[i].NEW) //acho o ultimo codigo de msg e seto no objeto e seto o valor
              this.items_usuarios[j].SEQ = parseInt(this.items_usuarios[j].SEQ) + (parseInt(h[i].NEW) * 100) //adiciono 100 para ficar no topo da sequencia
              this.items_usuarios[j].NEW = h[i].NEW

              agora += parseInt(h[i].NEW) //quantidade de novas msgs
              
            }              
          }
            
          

          if (this.aberto){

              //percorre usuarios online ou nao
              h = this.items_user_online
              for (let i = 0; i < h.length; i++) {

                if (h[i].USUARIO == r[j].USUARIO){
                  
                  this.items_usuarios[j].ONLINE = h[i].ONLINE
                  
                }              
              }
          }
      }

      //verifica se teve alteracao na qt das novas msgs ai.. toca o beep
      // console.log('agora:', agora);
      if (this.count_pendente !== agora){
          this.count_pendente = agora
          if (agora>0){
            this.play()
          } 
      }


      // defino a ordem do array
      this.items_usuarios = await this.items_usuarios.sort(this.arrayOrderBy)
    },

    arrayOrderBy(a,b) {
       return (b.SEQ - a.SEQ)
    },
    

    play() {
        // var audio = new Audio('https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3');
        // audio.play();

      // var snd = new Audio("data:audio/wav;base64,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");  
      // snd.play();

      var data = { soundurl : 'https://dsi.app.br/logos/alert.mp3'}
      // var data = { soundurl : 'http://soundbible.com/mp3/analog-watch-alarm_daniel-simion.mp3'}
      var audio = new Audio(data.soundurl);
      audio.play();

      

      if (this.isMobile == false){
        this.alerta2('Nova mensagem', 'blue')
      }      

    },

    scroll_to(id, posicao){
       //tem que definir um id para o componente 
       let container = document.getElementById([id])
       if (container !== null){

        if (posicao == -1){
          posicao = container.scrollHeight //pega o tamanho do scroll para ir ate o final
        }
        
        container.scrollTop = posicao // not working
        // container.scrollHeight
       }
       // let container = document.getElementById('id_sala')
     },

     getFormatTime(hora){
        if (hora !== undefined){
           let shora =   hora.substring(0,2) + ':'+ hora.substring(3,5)//formato a hh:mm
           return shora 
        }else{
          return ''
        }  
      },

      getFormatDate(data){
        let dia =   data.substring(8,10) + '/'+ data.substring(5,7)+ '/'+ data.substring(0,4);//formato a dd/mm/yyyy
        return dia 
      },

      async carregar_usuarios(){
          
          this.eu_sou =  DSirotinas.cripto(sessionStorage['84hfjdyruxy1_is'])
          this.eu_sou = this.eu_sou.trim()
          
          // console.log('eu_sou:' , this.eu_sou);

          await this.open_usuarios(this.eu_sou)
          // await this.open_usu_recentes(this.eu_sou)

          // this.simples = (this.items_usuarios.length < 15)
          this.simples = (sessionStorage.getItem('simples') === "true") 

      },

    faz(){
      // console.log(this.meuTimer);
      // clearTimeout(this.meuTimer);

      this.atu_chat_agora()
    },

   async TimerAtivar(){

      // TIMER PARA BUSCAR COUNT DE NOVAS MENSAGENS E VER USUARIOS ONLINE
      clearTimeout(this.meuTimer);

      this.meuTimer = 
            setTimeout(function(){
            

            this.refreshStatus()

            // const horas = new Date();
            // console.log('TimerAtivar: ', horas );

            this.TimerAtivar()
            
            }.bind(this), 1000 * 9);//9 segundos

    },
    
    TimerChatAgora(){

      clearTimeout(this.meuTimer2);

      this.meuTimer2 = 
            setTimeout(function(){
            
              if ((this.chat_agora)){

                this.atu_chat_agora()

                // const horas = new Date();
                // console.log('TimerChatAgora: ', horas );

                this.TimerChatAgora()
              }
            
            }.bind(this), 1000 * 9); //timer menor pq esta com a janela aberta

    },



    // --------------------------------SQL-------------------------------------

    //ABRE OS DADOS DA TABELA
    async crud_abrir_tabela(sql, items_name){
        await DSisql.crud_abrir_tabela(this, sql, items_name)

        // console.log(this.items_mensagens);
    }, 

    async crud_sql (sql) {
        await DSisql.crud_sql(this, sql)
    },

    alerta(text,color){
        DSibasico.alerta(this, text, color)
    },

    alerta2(text,color){
        // alert(text);
         this.snackbar2 = true;
         this.snack_text2= text;

         this.snack_color2 = color;
    },

    define_data_hora(){
        DSibasico.define_data_hora(this)//passo o this para que la ele defina as variaveis daqui
    },

    async tabela_create(tabela, obj_edita){
        await DSisql.tabela_create(this, tabela, obj_edita)
    },
  },


}
</script>

<style>
.container{
    /* max-width: 100%; */
  }

.names{
  color: #424949;
}


  .scrollable {
    overflow-y: auto;
    height: 90vh;
    background-color: blue;
  }

  /* box das mensagens */
  .chat-container{
    box-sizing: border-box;
    /* height: calc(100vh - 9.5rem); */
    /* height: 400px; */
    
    height: 50vh; /* 50% altura tela*/
    /* max-height: 600px; */
    /* width: 100vw; 100% largura tela*/
    overflow-y: auto;
    padding: 10px;
    background-color: #f2f2f2;
    /* background-color: white; */
    /* background-color: red; */
  }
  .message{
    /* margin-bottom: 3px; */
  }
  .message.own{
    text-align: right;
  }
  .message.own .content{
    /* background-color: lightgreen; */
    background-color: lightskyblue;
  }
  .chat-container .username{
    font-size: 14px;
    font-weight: bold;

  }
  .chat-container .content{
    padding: 2px 8px;
    background-color: white;
    /* background-color: lightgreen; */
    border-radius: 10px; /* bordas arrendondadas */
    display:inline-block;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12);
    max-width: 90%;
    word-wrap: break-word;
    font-size: 12px;
    color: black;
    }
  @media (max-width: 480px) {
    .chat-container .content{
      max-width: 60%;
    }
  }

  .hora{
    font-size: 9px;
  }

</style>